import { useEffect } from 'react';
import { useDebouncedCallback } from '../useDebouncedCallback/index.js';
export function useDebouncedEffect(callback, deps, delay, maxWait = 0) {
    useEffect(useDebouncedCallback(callback, deps, delay, maxWait), deps);
}
